import { call } from './utils';

//****POINT OF INTEREST CRUD

//pointOfInterest creation
export const createPointOfInterest = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/create',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//pointOfInterest update
export const updatePointOfInterest = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/update',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//pointOfInterest removePointOfInterest
export const removePointOfInterest = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/remove',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//pointOfInterest findAllPointOfInterests
export const findAllPointOfInterests = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/find/all',
    method: 'GET'
  });
//pointOfInterest findPointOfInterestById
export const findPointOfInterestById = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/find/by/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//pointOfInterest getAllPointOfInterestsByStationId
export const getAllPointOfInterestsByStationId = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//pointOfInterest getAllPointOfInterestsByStationId and their status
export const getAllPointOfInterestsAndStatusByStationId = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/find/all/status/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
export const getAllPointOfInterestsByUser = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/find/all/by/user',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
//pointOfInterest removePointOfInterestByStationId
export const removePointOfInterestByStationId = async (data, accessToken) =>
  await call({
    url: '/api/pointOfInterest/find/all/by/station/id',
    data: { data },
    token: accessToken,
    method: 'POST'
  });
